export default __webpack_public_path__ + "kishoralo-colored.png";